import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from '@/modules/shared/i18n/useTranslation';
import { openExternalUrl, openOpsDashboardWithAuth } from '@/modules/shared/utils';
import { resolveHitRoute } from '../routeMapping';
import type { GlobalSearchHit } from '../types';
import { en, th } from '../locales';

/**
 * View Details for a hit. Internal routes navigate in-app (and close the
 * panel); ops-dashboard routes navigate in the current tab via
 * openOpsDashboardWithAuth; external ones open the backend wizard_url in a
 * new tab.
 */
const ViewDetailsLink: React.FC<{ hit: GlobalSearchHit; onNavigated: () => void }> = ({ hit, onNavigated }) => {
  const { t } = useTranslation({ en, th });
  const navigate = useNavigate();
  const route = resolveHitRoute(hit);

  if (!route) return null;

  const handleClick = () => {
    if (route.kind === 'internal') {
      navigate(route.path);
      onNavigated();
    } else if (route.kind === 'ops-dashboard') {
      openOpsDashboardWithAuth(route.params);
    } else {
      openExternalUrl(route.url);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-sm font-medium text-primary hover:underline focus:outline-none"
      data-testid={`global-search-view-details-${hit.id}`}
    >
      {t('viewDetails')}
    </button>
  );
};

export default ViewDetailsLink;
